import DenominationsModalDialog from "./DenominationsModalDialog";

export default DenominationsModalDialog;
